import { routeUtil, urlUtil } from '@cmg/common';

import { NotesFilters } from './order-book/notes/NotesModel.util';

const { createRoute } = routeUtil;

/**
 * All routePath values here are relative to the "/offering-side-panel/:offeringId" segment
 * (see hooks/useOfferingSidePanelMatch.ts for why that segment can't be expressed as a v6 route
 * pattern) and are matched via `matchPath` against that hook's `rest` field, not through a
 * `<Routes>` tree.
 */

const offeringDetails = createRoute({
  routePath: `/details`,
  getUrlPath: (props: { cmgEntityKey?: string }) =>
    `/details${urlUtil.queryStringify({ cmgEntityKey: props.cmgEntityKey })}`,
});

const offeringSummary = {
  routePath: `/summary`,
  getUrlPath: () => `/summary`,
};

const orderBook = createRoute({
  routePath: `/order-book`,
  getUrlPath: (props: { cmgEntityKey?: string }) =>
    `/order-book${urlUtil.queryStringify({ cmgEntityKey: props.cmgEntityKey })}`,
});

const orderBookNewIndication = createRoute({
  routePath: `${orderBook.routePath}/indication-activity/new`,
  getUrlPath: (props: { cmgEntityKey?: string }) => {
    return `/order-book/indication-activity/new${urlUtil.queryStringify({
      cmgEntityKey: props.cmgEntityKey,
    })}`;
  },
});

const orderBookIndicationActivity = createRoute({
  routePath: `${orderBook.routePath}/indication-activity`,
  getUrlPath: (props: { cmgEntityKey?: string; indicationId?: string }) => {
    return `/order-book/indication-activity${urlUtil.queryStringify({
      cmgEntityKey: props.cmgEntityKey,
      indicationId: props.indicationId,
    })}`;
  },
});

const orderBookUpdateHistory = createRoute({
  routePath: `${orderBook.routePath}/update-history`,
  getUrlPath: (props: { cmgEntityKey: string }) => {
    return `/order-book/update-history${urlUtil.queryStringify({
      cmgEntityKey: props.cmgEntityKey,
    })}`;
  },
});

const orderBookCompliance = createRoute({
  routePath: `${orderBook.routePath}/compliance`,
  getUrlPath: (props: { cmgEntityKey?: string }) =>
    `/order-book/compliance${props.cmgEntityKey ? urlUtil.queryStringify(props) : ''}`,
});

const orderBookNotes = createRoute({
  routePath: `/notes`,
  getUrlPath: (props: { cmgEntityKey?: string; noteType?: NotesFilters }) =>
    `/notes${urlUtil.queryStringify({
      cmgEntityKey: props.cmgEntityKey,
      noteType: props.noteType,
    })}`,
});

const offeringSidePanelSellSideRoutes = {
  offeringDetails,
  offeringSummary,
  orderBook,
  orderBookIndicationActivity,
  orderBookNewIndication,
  orderBookUpdateHistory,
  orderBookNotes,
  orderBookCompliance,
};

export default offeringSidePanelSellSideRoutes;
